import axios from "../../utils/axios";
import { API_SUFFIX } from "../../config/app";

// 获取维保团队列表
export function apiMaintainList(query) {
    return axios({
        url: "/admin/index/w_teamlist" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 新增维护团队
export function apiAddwTeam(data, method = "post") {
    return axios({
        url: "/admin/index/addw_team" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 获取维保团队详情
export function apiTeamdetailsData(query) {
    return axios({
        url: "/admin/index/w_teamdetails" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 新增维护队员
export function apiAddwTeamuser(data, method = "post") {
    return axios({
        url: "/admin/index/addw_teamuser" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 获取编辑维护队员 信息
export function apiWuserEditData(query) {
    return axios({
        url: "/admin/index/w_useredit" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 提交编辑维护队员 信息
export function apiWuserEdit(data, method = "post") {
    return axios({
        url: "/admin/index/w_useredit" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 删除维保队员
export function apiWuserDelete(data, method = "post") {
    return axios({
        url: "/admin/index/w_delete" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 重置密码 GET
export function apiResetPassword(query) {
    return axios({
        url: "/admin/index/reset_password" + API_SUFFIX,
        method: "get",
        params: query
    });
}



// 获取编辑维护团队 信息
export function apiWuserTeamEditData(query) {
    return axios({
        url: "/admin/index/wbedit" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 编辑维护团队信息 提交
export function apiWuserTeamEditSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/wbedit" + API_SUFFIX,
        method: method,
        data: data
    });
}
